export class Alert {
  type: any;
  message: string;
}

export enum AlertType {
  Success,
  Error,
  Info,
  Warning,
}
